import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { OkAloneService } from 'src/app/ok-alone.service';

import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-groups-upload',
  templateUrl: './groups-upload.component.html',
  styleUrls: ['./groups-upload.component.scss']
})
export class GroupsUploadComponent implements OnInit {

  falseVal = false;

  uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  hasAnotherDropZoneOver: boolean;
  response: string;

  groups: any = null;
  groups2: any = null;

  step = 1;

  upload_errors = false;

  file_error = "";

  sync_workers = false;

  constructor(public okService: OkAloneService) {

    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    let url = this.okService.getUrl('groups/upload');
    this.uploader = new FileUploader({ url: url });

    this.response = '';

    this.setupLoader();
  }

  setupLoader() {

    let url: any = this.okService.getUrl('groups/upload');

    let token = "Bearer " + this.okService.session.token;

    let headers: { name: string; value: string }[] = [];
    if (this.okService.session.cid) {
      headers.push({ name: 'cid', value: this.okService.session.cid });
    }

    this.uploader = new FileUploader({
      url: url,
      authToken: token,
      headers: headers,
      itemAlias: "upload",
      disableMultipart: false,
    });

    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });

    this.uploader.response.subscribe(res => {

      this.file_error = "";

      let data = JSON.parse(res);

      console.log(data);

      if (data['error']) {
        this.file_error = data['error'];
      } else {

        this.upload_errors = false;
        this.groups = data;

        let self = this;
        _.forEach(this.groups, function (group: any) {
          if (group.errors && group.errors.length > 0) {
            self.upload_errors = true;
          }
        });

        this.step = 2;
      }

    });

  }

  uploadGroups() {

    this.okService.post("groups/upload", { "groups": this.groups, "sync": this.sync_workers })
      .subscribe((data) => {

        this.groups2 = data.body;
        this.step = 3;

      });
  }

  ngOnInit(): void {
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  reset() {
    this.upload_errors = false;
    this.groups = null;
    this.sync_workers = false;
    this.setupLoader();
    this.step = 1;
  }

}
